import React, { Fragment } from 'react';
import { Type } from '@spotify-internal/encore-creator-web';
import styled from 'styled-components';
import tokens from '@spotify-internal/encore-foundation';
import { Country, Language, Category } from '../../types';
import { PodcastModalBody } from '../Shared/PodcastModal';

const FIELD_INDICATOR = {
  country: 'Where your podcast is made',
  language: 'Primary language spoken',
};

const ItemContainer = styled.div`
  border-top: 1px solid #bdbdbd;
`;

const Item = styled.div`
  align-items: center;
  border-bottom: 1px solid #bdbdbd;
  padding: ${tokens.spacer16} 0;
  display: flex;

  @media (max-width: 480px) {
    flex-direction: column;
    align-items: start;
  }
`;

const StyledIndicator = styled(Type.p)`
  margin-left: ${tokens.spacer8};
  margin-right: ${tokens.spacer32};
  width: 200px;

  @media (max-width: 480px) {
    margin: 0;
  }
`;

interface Props {
  countryOfOrigin: Country;
  language: Language;
  categories: Category[];
}

export function Review(props: Props) {
  const renderItem = (key: string, value: string) => (
    <Item>
      <StyledIndicator variant={Type.body2} color="gray60" condensed>
        {FIELD_INDICATOR[key]}
      </StyledIndicator>
      <Type.p condensed>{value}</Type.p>
    </Item>
  );

  const renderCategory = (category: Category, index: number) => (
    <Fragment key={category.value}>
      <Item>
        <StyledIndicator variant={Type.body2} color="gray60" condensed>
          {index === 0 ? 'Primary category' : 'Additional category'}
        </StyledIndicator>
        <Type.p condensed>{category.name}</Type.p>
      </Item>
      <Item>
        <StyledIndicator variant={Type.body2} color="gray60" condensed>
          Sub-category
        </StyledIndicator>
        <Type.p condensed>
          {category.subcategories.length ? category.subcategories.map(s => s.name).join(', ') : '-'}
        </Type.p>
      </Item>
    </Fragment>
  );

  return (
    <div data-testid="review-step">
      <PodcastModalBody data-qa="review-and-submit">
        <Type.h1 variant={Type.heading2}>Does everything look OK?</Type.h1>
        <Type.p variant={Type.body1}>
          {"You won't be able to edit this once you hit "}
          <strong>submit</strong>.
        </Type.p>
        <ItemContainer>
          {renderItem('country', props.countryOfOrigin.name)}
          {renderItem('language', props.language.name)}
          {props.categories.map((category, index) => renderCategory(category, index))}
        </ItemContainer>
      </PodcastModalBody>
    </div>
  );
}
